import { Image } from "react-bootstrap";
import { FailureIcon, RightArrowIcon } from "src/assets";
import i18n from "src/i18n";
import { ModalFailureProps, typedMemo } from "src/types";
import { Button, Modal } from "src/ui/widgets";

export const ModalFailure = typedMemo(
  ({
    visible,
    icon = FailureIcon,
    description = (
      <p className="mt-4 font-16 pre-line">
        {i18n.t("error.page_error_description")?.toString()}
      </p>
    ),
    onClose,
    onCloseHome,
    button = {
      flavor: "accent",
      text: i18n.t("commons.reload_page"),
      iconLeft: RightArrowIcon,
      classesIconLeft: "me-2 filter-ffffff",
      onPress: () => {
        onClose?.();
        window.location.reload();
      },
    },
    buttonHome = false,
    buttonReload = false,
  }: ModalFailureProps) => {
    return (
      <Modal visible={visible} onClose={onClose}>
        <div className="d-flex align-items-center justify-content-center p-1">
          <div className="d-inline text-center">
            {icon && <Image src={icon} className="filter-F34747" />}
            {description && (
              <p className="mt-4 font-16 pre-line">{description}</p>
            )}
          </div>
        </div>
        <div className="d-flex flex-md-row flex-column justify-content-between px-1">
          {buttonHome && onCloseHome && (
            <div className="mt-4 mb-2 d-flex align-items-center justify-content-center order-2 order-md-1">
              <Button
                text={i18n.t("commons.back_to_homepage")}
                flavor="primaryBack"
                classes="transparent-accent d-flex justify-content-center button-submit m-md-0"
                classesText="font-medium-s text-uppercase"
                onPress={onCloseHome}
              />
            </div>
          )}
          {buttonReload && button?.onPress && (
            <div className="mt-4 mb-2 d-flex align-items-center justify-content-center order-1 order-md-2">
              <Button
                {...button}
                iconLeft=""
                flavor="primaryNext"
                classes="primary d-flex justify-content-center button-submit m-md-0"
                classesText="font-medium-s text-uppercase"
              />
            </div>
          )}
        </div>
      </Modal>
    );
  }
);
